import React from "react";
import Dashboard from '../../../components/Dashboard';


const DashboardContainer = () => {
    return (<Dashboard />);
}

export default DashboardContainer;